/**
 * @author Swathi
 * @description This Component is mainly for Creating Jobplans and Task
 * @View Table with crud operations of Jobplanes
 */
import { connect } from 'react-redux';
import { constant } from '../../../Utils/constants';
import { Form, Input, message, Select ,Button} from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import InputComponent from '../../../Widgets/InputComponent';
import translation from '../../../../../commons/translation';

import {
  getDeviceList,
  // getOrganisationsList,
  // getSitesList,
  submitJobPlan,
  // getJobPlanById,
  getStatus
} from '../../../Utils/FormCalls';

const { Option } = Select;

const FollowUpWork = (props) => {
  const [deviceList, setDeviceList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [formObject, setFormObject] = useState(props.formObject || {});
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});

  const taskRef = useRef();
  const schedulingWorkOrderRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const deviceResponse = await getDeviceList();
        setDeviceList(deviceResponse?.data || []);

        const statusResponse = await getStatus();
        setStatusList(statusResponse);
      } catch (error) {
        message.warning(`${error.message}`);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (props.formObject && Object.keys(props.formObject).length === 0 && Object.keys(formObject).length === 0) {
      onReset();
    }
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    if (props.formObject && Object.keys(props.formObject).length === 0) {
      schedulingWorkOrderRef.current.setFieldsValue(props.formObject);
      taskRef.current.setFieldsValue(props.formObject.TaskData);
    }

    if (props.formObject !== formObject) {
      setFormObject(props.formObject);
    }
  }, [props, formObject, translationCache]);

  const handleChange = (value, key) => {
    const updatedFormObject = {
      ...formObject,
      [key]: value
    };
    schedulingWorkOrderRef.current.setFieldsValue(updatedFormObject);
    setFormObject(updatedFormObject);
  };

  const onFinish = async (values) => {
    const payload = {
      ...formObject,
      ...values
    };
    const statusResponse = await submitJobPlan(payload);
    if (statusResponse?.message) {
      message.success(statusResponse.message);
      onReset();
    } else if (statusResponse?.Error) {
      message.error(statusResponse.Error);
    }
  };

  const onReset = () => {
    taskRef.current.resetFields();
    schedulingWorkOrderRef.current.resetFields();
  };

  // Uncomment and implement this function if needed
  // const jobPlanOnChange = async (value) => {
  //   const formObject = await getJobPlanById(value);
  //   setFormObject(formObject);
  // };

  return (
    <>
      <Form
        onFinish={onFinish}
        name={'FollowUpWork'}
        ref={schedulingWorkOrderRef}
        className="jobplan"
        initialValues={formObject}
        layout="horizontal"
        labelCol={{ flex: '130px' }}
        labelAlign="right"
        labelWrap
      >
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Form.Item
            label={translation(translationCache, constant.workOrder)}
            name="WorkOrderId"
            rules={[{ required: false, message: 'Please Input WorkOrderId!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <InputComponent
              placeholder={translation(translationCache, 'Input WorkOrder')}
              style={{ width: '70%' }}
            />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, constant.description)}
            name="Description"
            rules={[{ required: false, message: 'Please Input Description!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <InputComponent
              placeholder={translation(translationCache, 'Input Description')}
              style={{ width: '70%' }}
            />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, constant.asset)}
            name="Asset"
            rules={[{ required: false, message: 'Please Input Asset!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <Select
              style={{ width: '70%' }}
              mode={'multiple'}
              placeholder={translation(translationCache, 'Select Device')}
            >
              {deviceList.map((device, index) => (
                <Option key={index} value={device.Id}>
                  {device.Name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={translation(translationCache, constant.location)}
            name="Location"
            rules={[{ required: false, message: 'Please Input Location!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <Select
              style={{ width: '70%' }}
              mode={'multiple'}
              placeholder={translation(translationCache, 'Select Location')}
            >
              {deviceList.map((device, index) => (
                <Option key={index} value={device.Id}>
                  {device.Name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={translation(translationCache, constant.status)}
            name="StatusId"
            style={{ width: '100%', flex: '50%' }}
          >
            <Select
              style={{ width: '70%' }}
              placeholder={translation(translationCache, 'Select Status')}
              onChange={(value) => handleChange(value, 'StatusId')}
            >
              {statusList.map((status, index) => (
                <Option key={index} value={status.Id}>
                  {status.Status}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item style={{ width: '100%', flex: '50%' }}>
            <Input style={{ display: 'none' }} />
          </Form.Item>
        </div>

        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Form.Item>
            <Button htmlType="submit">
              {translation(translationCache, constant.save)}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(FollowUpWork);